import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

@Component({
  selector: 'app-file-viewer',
  templateUrl: './file-viewer.component.html',
  styleUrls: ['./file-viewer.component.scss']
})
export class FileViewerComponent implements OnInit {
  fileUrl: any;
  fileType: string;

  constructor(
    private dialogRef: MatDialogRef<FileViewerComponent>,
    @Inject(MAT_DIALOG_DATA) private data,
    private sanitizer: DomSanitizer
  ) {}

  isLoading = true;

ngOnInit() {
  const extension = this.data.fileName?.split('.').pop()?.toLowerCase();
  this.fileType = extension;
  this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.file);

  // For PDF files, we set a timeout to simulate loading
  if (this.fileType === 'pdf') {
    setTimeout(() => {
      this.isLoading = false;
    }, 2000); // Simulate a 2-second loading time
  }
}

onLoad() {
  this.isLoading = false;
}



  onClicked() {
    this.dialogRef.close();
  }
}